'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconPower = function IconPower(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ fill: 'none', height: '24', viewBox: '0 0 24 24', width: '24' }, custom),
    _react2.default.createElement(
      'g',
      { fill: color },
      _react2.default.createElement('path', { d: 'M12.0033333,9.5 C11.5425,9.5 11.17,9.13773585 11.17,8.69137466 L11.17,2.80862534 C11.17,2.36226415 11.5425,2 12.0033333,2 C12.4633333,2 12.8366667,2.36226415 12.8366667,2.80862534 L12.8366667,8.69137466 C12.8366667,9.13773585 12.4633333,9.5 12.0033333,9.5' }),
      ' ',
      _react2.default.createElement('path', { d: 'M12.0008331,22 C7.17471199,22 3.25,17.9724092 3.25,13.0206356 C3.25,9.20934295 5.6109921,5.80414363 9.124155,4.54824662 C9.55986385,4.39179383 10.033062,4.62861035 10.1846853,5.0740306 C10.3363087,5.52030578 10.1063744,6.00761776 9.67233171,6.16321562 C6.82814434,7.17973131 4.91619061,9.93603625 4.91619061,13.0206356 C4.91619061,17.0294178 8.09361611,20.2901334 12.0008331,20.2901334 C15.9055508,20.2901334 19.0838094,17.0294178 19.0838094,13.0206356 C19.0838094,9.93603625 17.1735219,7.17973131 14.3276683,6.16321562 C13.8927925,6.00761776 13.6636913,5.52030578 13.8144816,5.0740306 C13.9661049,4.62861035 14.4393031,4.39264876 14.875845,4.54824662 C18.3890079,5.80414363 20.75,9.20934295 20.75,13.0206356 C20.75,17.9724092 16.825288,22 12.0008331,22' }),
      ' '
    )
  );
};

IconPower.propTypes = {
  color: _propTypes2.default.string
};

IconPower.defaultProps = {
  color: _colors2.default.icons
};

IconPower.displayName = 'IconPower';

exports.default = IconPower;
module.exports = exports.default;